var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"mt-1 text-xs text-green-500"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'check-circle']}}),_c('span',{staticClass:"ml-1",domProps:{"innerHTML":_vm._s(_vm.text)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }